import { get, forEach, isEmpty, identity, orderBy } from 'lodash'
import { ONE_TIME_TRIGGER } from 'components/SegmentSelector/outreach-message-trigger-constants'

const shouldAddMessages = (trigger, key) => {
  //this is a temporary solution. Delete this once we have multiple APIs for the different pages of outreach (automated vs one-time)
  const isOneTime = key === ONE_TIME_TRIGGER
  return trigger === ONE_TIME_TRIGGER ? isOneTime : !isOneTime
}

const orderers = {
  [ONE_TIME_TRIGGER]: (messages) => orderBy(messages, ['IsDraft'], ['desc']),
}

export const formatMessages = (unformattedMessages, trigger) => {
  const messages = []
  let hasMessages = false
  let messageCount = 0
  forEach(unformattedMessages, (values, key) => {
    if (shouldAddMessages(trigger, key)) {
      if (!isEmpty(values) && !hasMessages) {
        hasMessages = true
      }
      const orderer = get(orderers, trigger, identity)
      messages.push({
        trigger: key,
        messages: orderer(values),
      })
      messageCount += values.length
    }
  })
  return { hasMessages, messages, messageCount }
}
